// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonMoreCenteredCaution_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.4389 13.8246C17.691 13.3918 18.309 13.3918 18.5611 13.8246L23.9086 23.0044C24.1649 23.4445 23.8518 24 23.3475 24H12.6525C12.1482 24 11.8351 23.4445 12.0914 23.0044L17.4389 13.8246Z" fill="#FDCA40"/>
  <path d="M17.4389 13.8246C17.691 13.3918 18.309 13.3918 18.5611 13.8246L23.9086 23.0044C24.1649 23.4445 23.8518 24 23.3475 24H12.6525C12.1482 24 11.8351 23.4445 12.0914 23.0044L17.4389 13.8246Z" stroke="white"/>
  <path d="M18.9792 15.3809 17.021 16.0194V20.2764H18.9792V15.3809ZM18.9792 21.2554H17.021V23.2137H18.9792V21.2554Z" fill="#1A2329"/>
  <path d="M7 12C7 13.1046 6.10457 14 5 14 3.89543 14 3 13.1046 3 12 3 10.8954 3.89543 10 5 10 6.10457 10 7 10.8954 7 12ZM14 12C14 13.1046 13.1046 14 12 14 10.8954 14 10 13.1046 10 12 10 10.8954 10.8954 10 12 10 13.1046 10 14 10.8954 14 12ZM18.645 13.9686C18.645 13.9686 18.645 13.9686 18.645 13.9686V13.9686ZM17.0249 11.6835C18.1732 11.2334 19.5866 11.6115 20.2893 12.8179L20.5495 13.2646C20.8311 12.92 21 12.4797 21 12 21 10.8954 20.1046 10 19 10 18.0031 10 17.1766 10.7293 17.0249 11.6835Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonMoreCenteredCaution is a generated icon component.
 */
let IconCommonMoreCenteredCaution = IconCommonMoreCenteredCaution_1 = class IconCommonMoreCenteredCaution extends IconBaseElement {
    render() {
        return html `${IconCommonMoreCenteredCaution_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonMoreCenteredCaution.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonMoreCenteredCaution = IconCommonMoreCenteredCaution_1 = __decorate([
    customElement('zui-icon-common-more-centered-caution')
], IconCommonMoreCenteredCaution);
export { IconCommonMoreCenteredCaution };
